export default __webpack_public_path__ + "static/Relationship2-058ae86026190654ef3e9d6ee25f8a63.png";